// awsconfig.js
const awsconfig = {
    Auth: {
      Cognito: {
        userPoolId: 'us-east-1_Rd5HzgEP6', // Your Cognito User Pool ID
        userPoolClientId: '6n0qnkuuuvgifen1877bcd2gp1', // Your Cognito App Client ID
        identityPoolId: 'us-east-1:8cede50c-f02d-49fa-96c8-78a7822f4e39L', // Your Cognito Identity Pool ID (if applicable)
      },
    },
  };
  
  export default awsconfig;
  